import React from "react";
import "../../../../../css/pages/ca_pages/finances/models/books_ledgers_model/BusinessCard.css";

const BusinessCard = ({ business, onOpen }) => {
    const businessName =
        business.business_name ||
        business.name ||
        "Unnamed Business";

    const gstin =
        business.gstin ||
        "GSTIN not available";

    const initial = businessName
        .trim()
        .charAt(0)
        .toUpperCase();

    return (
        <article
            className="business-card"
            onClick={onOpen}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onOpen();
                }
            }}
        >
            <div className="business-card-content">

                {/* BUSINESS IDENTITY */}
                <div className="business-card-identity">
                    <div className="business-avatar">
                        {initial}
                    </div>

                    <h3
                        className="business-card-name"
                        title={businessName}
                    >
                        {businessName}
                    </h3>
                </div>

                {/* BUSINESS META + ACTION */}
                <div className="business-card-bottom">

                    <div className="business-gstin">
                        <span className="business-gstin-label">
                            GSTIN
                        </span>

                        <span
                            className="business-gstin-value"
                            title={gstin}
                        >
                            {gstin}
                        </span>
                    </div>

                    <button
                        type="button"
                        className="business-workspace-button"
                        onClick={(event) => {
                            event.stopPropagation();
                            onOpen();
                        }}
                    >
                        <span>Open Workspace</span>

                        <span className="business-workspace-arrow">
                            →
                        </span>
                    </button>

                </div>
            </div>
        </article>
    );
};

export default BusinessCard;
